import { render, staticRenderFns } from "./Subtasks.vue?vue&type=template&id=e466c676&scoped=true&"
import script from "./Subtasks.vue?vue&type=script&lang=js&"
export * from "./Subtasks.vue?vue&type=script&lang=js&"
import style0 from "./Subtasks.vue?vue&type=style&index=0&id=e466c676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e466c676",
  null
  
)

export default component.exports